import { Box } from '@mui/material';
import { MinorTitle } from '../shared/typography/PrimaryTypography';

const SubCopySection = () => (
  <Box
    sx={{
      backgroundColor: '#1A3E5C',
      px: { xs: 3, md: 10 },
      py: { xs: 6, md: 10 }
    }}
  >
    <MinorTitle weight="Bold" dark sx={{ lineHeight: 1.5, mb: 4 }}>
      Syntiro shows you what is happening right now: inside the equipment, systems and utilities
      that run your operations.
    </MinorTitle>

    <Box sx={{ width: 64, height: 3, backgroundColor: '#00AB97', mb: 4 }} />

    <MinorTitle weight="Medium" sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
      Built by a company that designs, operates and optimises real-world energy systems,
      Syntiro&apos;s operational DNA makes sustainability performance measurable, improvable and
      credible.
    </MinorTitle>
  </Box>
);

export default SubCopySection;
